module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal-de-prorrogacao",
    on: {
      "close": function($event) {
        return _vm.$emit('fechar')
      }
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmar.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("\n      Prorrogar prazo para envio?\n    ")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('p', {
    staticClass: "texto texto_medio texto_cor-cinza u-margem-inferior-media"
  }, [_vm._v("\n      " + _vm._s(_vm.mensagemPrincipal) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-margem-inferior-media"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "dataDeRecebimentoDoOficio"
    }
  }, [_vm._v("\n        Data de recebimento do ofício\n        "), _c('span', {
    staticClass: "dialogo-de-situacao__obrigatorio",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataDeRecebimentoDoOficio),
      expression: "dataDeRecebimentoDoOficio"
    }],
    staticClass: "formulario__input",
    class: {
      formulario__input_erro: _vm.erro
    },
    attrs: {
      "id": "dataDeRecebimentoDoOficio",
      "type": "date",
      "max": _vm.hoje,
      "required": ""
    },
    domProps: {
      "value": (_vm.dataDeRecebimentoDoOficio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataDeRecebimentoDoOficio = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.erro) ? _c('p', {
    staticClass: "formulario__mensagem formulario__mensagem_erro"
  }, [_c('i', {
    staticClass: "far fa-exclamation-circle formulario__mensagem-icone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.erro) + "\n      ")]) : _c('p', {
    staticClass: "dialogo-de-situacao__ajuda"
  }, [_vm._v("\n        Data em que a AGEHAB recebeu o ofício solicitando a prorrogação.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-de-prorrogacao__nova-data"
  }, [_c('span', {
    staticClass: "modal-de-prorrogacao__nova-data-rotulo texto_pequeno"
  }, [_vm._v("\n        Nova data limite:\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "modal-de-prorrogacao__nova-data-valor texto_medio"
  }, [_vm._v("\n        " + _vm._s(_vm.novaDataLimiteFormatada || "--") + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "dialogo-de-situacao__ajuda texto_mini",
    staticStyle: {
      "margin": "0",
      "font-weight": "700",
      "color": "var(--cor-cinza-50)"
    }
  }, [_vm._v("\n        Novo limite do prazo após a prorrogação.\n      ")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("\n        Observação (registrada no histórico)\n      ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.observacao),
      expression: "observacao"
    }],
    staticClass: "formulario__textarea",
    attrs: {
      "id": "observacao",
      "placeholder": "Descreva a movimentação para os demais setores...",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.observacao = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-superior-media u-margem-inferior-media"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_contorno botao_medio botao_cor-cinza u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('fechar')
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-primaria botao_medio",
    class: {
      'is-loading': _vm.carregando
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.carregando
    }
  }, [_vm._v("\n        Confirmar prorrogação\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-053b2bfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/ModalDeProrrogacao.vue
// module id = 1086
// module chunks = 1